/**
 * 环境配置文件
 * 统一管理API基础URL和其他环境相关配置
 */

// 获取当前环境
const getCurrentEnv = () => {
  // 优先使用环境变量
  if (process.env.NODE_ENV) {
    return process.env.NODE_ENV
  }
  
  // 根据域名判断环境
  const hostname = window.location.hostname
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'development'
  }
  
  // 默认为生产环境
  return 'production'
}

// 环境配置
const envConfig = {
  development: {
    // 开发环境 - 可以指向本地后端
    API_BASE_URL: 'http://localhost:8891/api',
  },
  production: {
    // 生产环境
    API_BASE_URL: 'https://mxdapi.2048d.cn/api'
  },
  test: {
    // 测试环境
    API_BASE_URL: 'https://mxdapi.2048d.cn/api'
  }
}

// 当前环境
const currentEnv = getCurrentEnv()

// 导出当前环境的配置
export const ENV_CONFIG = envConfig[currentEnv] || envConfig.production

// 导出API基础URL（最常用的配置）
export const API_BASE_URL = ENV_CONFIG.API_BASE_URL

// 导出其他可能需要的配置
export const CONFIG = {
  // API相关
  API_BASE_URL: ENV_CONFIG.API_BASE_URL,
  API_TIMEOUT: 10000,
  UPLOAD_TIMEOUT: 300000, // 5分钟
  
  // 应用信息
  APP_NAME: '花狐 · 冒险岛枫星',
  APP_VERSION: '1.0.0',
  
  // 当前环境
  CURRENT_ENV: currentEnv,
  
  // 是否为开发环境
  IS_DEV: currentEnv === 'development',
  
  // 是否为生产环境  
  IS_PROD: currentEnv === 'production'
}

// 打印当前配置信息（仅开发环境）
if (CONFIG.IS_DEV) {
  console.log('🔧 当前环境配置:', {
    环境: currentEnv,
    API基础URL: CONFIG.API_BASE_URL,
    完整配置: CONFIG
  })
}

export default CONFIG
